import { SelectOptions } from '@/ui/types';
import { t } from '@/ui/i18n/i18n';
import { USER_ROLE_ADMINISTRATOR } from '@/services/api/resources/user';

export const mergedRoleOptions = (roleOptions: SelectOptions) => [
  {
    value: USER_ROLE_ADMINISTRATOR,
    label: t('user.administrator'),
  },
].concat(roleOptions);
